import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import SiteSetting from '../../Context/SiteSetting';
import './TermsConditions.scss';

const TermsConditions = () => {
    const { t } = useTranslation();
    const context = useContext(SiteSetting);

    return (<div className='terms-and-conditions'>
        <div className='title'>{t('Terms and Conditions')}</div>
        <div className='sun-title' dangerouslySetInnerHTML={{__html: context.setting.terms_and_conditions}}></div>
    </div>);
};

export default TermsConditions;
